/* 


@PRAKT


   _____________________________________________________________

   |
   | MODAL INFO
   |
   _____________________________________________________________
*/

import gsap from 'gsap';

/* ______________________________________________________________

   |
   | CLASS
   |
   ______________________________________________________________
*/

export default class ModalInfo {
    constructor() {
        this.init();
        this.shopifyEditor();
    }

    init() {
        this.is_in_customizer = this.isInCustomizer();
        this.modal = document.querySelector( '#modal_info' );

        let once;
        if( this.is_in_customizer ) once = true;
        else once = this.controlSessionStorage();

        if( !this.modal || !once ) return;

        this.modal.style.display = 'flex';
        this.container = document.querySelector( '#modal_info .mi_container' );
        this.button = this.modal.querySelector( '.close .button' );
        this.overlay = this.modal.querySelector( '.overlay' );
        this.title = this.modal.querySelector( '.title' );
        this.content = this.modal.querySelector( '.content' );

        this.icon = this.modal.querySelector( '.icon' );
        this.alert = this.modal.querySelector( '.alert' );
        this.close_container = this.modal.querySelector( '.close' );

        this.open();
        this.clickClose(); 
    }

    isInCustomizer() {
        if( window.Shopify && window.Shopify.designMode ) return true;
        else return false;
    }

    open() {
        gsap.fromTo( this.overlay, {
            opacity: 0
        }, {
            duration: 0.5,
            ease: 'power3.inOut',
            opacity: 1
        } );

        gsap.fromTo( this.container, {
            opacity: 0,
            y: -20
        }, {
            duration: 0.5,
            ease: 'power3.inOut',
            opacity: 1,
            y: 0
        } );

        gsap.fromTo( this.title, {
            height: 0
        }, {
            duration: 1,
            ease: 'power3.inOut',
            height: 'auto'
        } );

        gsap.fromTo( this.content, {
            opacity: 0,
            y: -20
        }, {
            delay: 0.5,
            duration: 1,
            ease: 'power3.out',
            opacity: 1,
            y: 0
        } );

        gsap.fromTo( this.icon, {
            opacity: 0,
            x: 20
        }, {
            delay: 0.2,
            duration: 1,
            ease: 'power3.inOut',
            opacity: 1,
            x: 0
        } );

        gsap.fromTo( this.close_container, {
            opacity: 0,
        }, {
            delay: 0.4,
            duration: 1,
            ease: 'power3.out',
            opacity: 1
        } );

        if( !this.alert ) return;
        gsap.fromTo( this.alert, {
            opacity: 0,
            x: 20
        }, {
            delay: 0.4,
            duration: 1,
            ease: 'power3.inOut',
            opacity: 1,
            x: 0
        } );
    }

    close() {
        this.setSessionStorage();

        gsap.to( this.overlay, {
            duration: 0.5,
            ease: 'power3.inOut',
            opacity: 0
        } );

        gsap.to( this.container, {
            duration: 0.5,
            ease: 'power3.inOut',
            opacity: 0,
            y: 50,
            onComplete: () => {
                this.modal.remove();
            }
        } );
    }

    clickClose() {
        this.button.addEventListener( 'click', this.close.bind( this ) );
        this.overlay.addEventListener( 'click', this.close.bind( this ) );
    }

    controlSessionStorage() {
        const data = sessionStorage.getItem( "hnx_modal_info" );
        return data !== 'closed';
    }

    setSessionStorage() {
        if( !this.is_in_customizer ) sessionStorage.setItem( "hnx_modal_info", "closed" );
    }

    shopifyEditor() {
        if( Shopify.designMode ) {
            document.addEventListener('shopify:section:load', (event) => {
                console.log('ok');
                this.init();
            });
        }
    }

}